import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import LoginModal from './LoginModal';
import RegisterModal from './RegisterModal';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showRegisterModal, setShowRegisterModal] = useState(false);

  useEffect(() => {
    if (!loading && !user) {
      setShowLoginModal(true);
    }
  }, [loading, user]);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!user) {
    return (
      <>
        <div className="auth-required-page">
          <div className="auth-required-content">
            <h2>Authentication Required</h2>
            <p>Please log in to access your dashboard</p>
            <button 
              className="btn-primary"
              onClick={() => setShowLoginModal(true)}
            >
              Log In
            </button>
            <button 
              className="btn-secondary"
              onClick={() => setShowRegisterModal(true)}
            >
              Create Account
            </button>
          </div>
        </div>

        <LoginModal 
          isOpen={showLoginModal}
          onClose={() => setShowLoginModal(false)}
          onSwitchToRegister={() => {
            setShowLoginModal(false);
            setShowRegisterModal(true);
          }}
        />

        <RegisterModal
          isOpen={showRegisterModal}
          onClose={() => setShowRegisterModal(false)}
          onSwitchToLogin={() => {
            setShowRegisterModal(false);
            setShowLoginModal(true);
          }}
          redirectTo="/dashboard"
        />
      </>
    );
  }

  return children;
};

export default ProtectedRoute;